<template>
	<edit-layout @save="handleSave()" @cancel="$emit('browsMode')" class="auth-form">
		<AuthDesc></AuthDesc>
		<el-form label-position="left" label-width="85px" ref="authForm" :model="ruleForm">
			<!-- <el-form-item v-if="!is18" :label="!is18 ? '超級英雄' : '夥伴'">
				<div class="col" gutter="10" align-x="left">
					<el-form-item v-for="(member, i) in ruleForm.teamMembers" :key="i" :label="member.name">
						<el-input v-model="member.parent" placeholder="法定代理人姓名"></el-input>
					</el-form-item>
				</div>
			</el-form-item> -->
			<el-form-item :label="!is18 ? '輔導員' : '代表人'">
				<template v-for="(counselor, i) in editStoryData.counselors">{{counselor.name}}<br :key="i"></template>
			</el-form-item>
			<el-form-item label="同意授權">
				<el-radio v-model="editStoryData.agree_authorize" :label="true">同意</el-radio>
				<el-radio v-model="editStoryData.agree_authorize" :label="false">不同意</el-radio>
				<br>
				<small>* 勾選「同意」視為同意下列條款</small>
			</el-form-item>
		</el-form>
		<AuthDesc2></AuthDesc2>
	</edit-layout>
</template>

<script>
import EditLayout from "./EditLayout.vue";
import AuthDesc from "./AuthDesc.vue";
import AuthDesc2 from "./AuthDesc2.vue";
import { mapState, mapMutations, mapActions } from "vuex";
import _ from "lodash";

export default {
	props: ["is18"],
	data() {
		return {
			ruleForm: {
				teamMembers: [],
				counselors: []
			}
		};
	},
	computed: {
		...mapState("story", ["editStoryData"])
	},
	methods: {
		...mapMutations("story", ["updateEditStoryData"]),
		...mapActions("story", ["updateStory", "checkProgress"]),
		init() {
			this.ruleForm.teamMembers = _.cloneDeep(this.editStoryData.team_members);
			this.ruleForm.counselors = _.cloneDeep(this.editStoryData.counselors);
		},
		async handleSave() {
			this.$refs["authForm"].validate(async valid => {
				if (valid) {
					this.ruleForm.teamMembers.forEach((member, i) => {
						_.assign(this.editStoryData.team_members[i], member);
					}, this);
					this.ruleForm.counselors.forEach((member, i) => {
						_.assign(this.editStoryData.counselors[i], member);
					}, this);
					let data = {
						id: this.editStoryData.id,
						team_members: this.editStoryData.team_members,
						counselors: this.editStoryData.counselors,
						agree_authorize: this.editStoryData.agree_authorize
					};
					this.updateEditStoryData(data);
					data.progress = await this.checkProgress();
					await this.updateStory(data);
					this.$emit("browsMode");
					this.$message.success("儲存成功");
				} else {
					this.$message.error("身分證四碼請輸入四位數數字");
				}
			});
		}
	},
	created() {
		this.init();
	},
	mounted() { },
	components: {
		EditLayout,
		AuthDesc,
		AuthDesc2,
	}
};
</script>

<style lang="scss" scoped>
.auth-form {
	font-size: 14px;
}
</style>